import React, { useEffect, useState } from "react";
import { Button, Divider, Flex, Space } from "antd";
import { useForm } from "react-hook-form";
import styled from "styled-components";
import Theme from "../../styles/Theme/Theme";
import { useTranslation } from "react-i18next";
import { Text } from "../Global/Atomics/Text";
import { useAuthContext } from "../../contexts/AuthContext";
import i18next from 'i18next';
import { Dropdown } from 'antd';
import { Icon } from '@synergy/icons';
import logger from "../../server/server";
import Spinner from "../Global/Atomics/Spinner";
import { getTenantConfig } from "../../utils/config/tenantConfig";

const USERNAME_ID = 'username';
const PASSWORD_ID = 'password';
const NEW_PASSWORD = 'newPassword';
const REPEAT_MEW_PASSORD = 'repeatNewPassword';
const PASSWORD_CODE = 'passwordCode';//Send to client when he/she/they try to recover password
const MFA_CODE = 'mfaCode';

//#region  Styled Components
//Where we define the styles, CSS and other aspects for the page components
const LoginPage = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const LanguageWrapper = styled.div`
    height: auto;
    margin: 0 12px;
`;

const LoginForm = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 40%;
`;
const Input = styled.input`
    width: 100%;
    padding: 12px 20px;
    margin: 8px 0;
    display: inline-block;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
`;
const SummitButton = styled.button`
    width: 100%;
    background-color: #86bc25;
    color: white;
    padding: 16px 24px;
    margin: 8px 0;
    border: none;
    cursor: pointer;
`;
const LoginWithSSO = styled.button`
    width: 100%;
    background-color: #86bc25;
    color: white;
    padding: 16px 24px;
    margin: 8px 0;
    border: none;
    cursor: pointer;
`;

const Image = styled.img`
    width: 100%;
    height: 170px;
`;
const ImageWrapper = styled.div`
    display: flex;
    width: 60%;
    height: 100%;
    min-height: 100%;
    justify-content: center;
    align-items: center;
    background-color: ${Theme.color["black-1"]};

    .logo{
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;
const GlobalWrapperRight = styled.div`
    position: absolute;
    top: 32px;
    right: 1%;
    height: auto;
`;
const GlobalWrapperLeft = styled.div`
    position: absolute;
    top: 32px;
    right: 61%;
     height: auto;
`;
const IconDropdown = styled.div`
    :hover{
        cursor: pointer;
    }
`;
//#endregion

export function LoginScreen() {
    const { t } = useTranslation();
    const { user, tenant } = useAuthContext();
    const [sendEmailPage, setSendEmailPage] = useState(true);
    const tenantConfig = getTenantConfig();

    const [inputEmail, setInputEmail] = useState(false);
    const [inputPassword, setInputPassword] = useState(false);
    const [inputRepeatPassword, setInputRepeatPassword] = useState(false);
    const [inputNewPassword, setInputNewPassword] = useState(false);
    const [inputRepeatNewPassword, setInputRepeatNewPassword] = useState(false);
    const [error, setError] = useState(false);

    const { register: registerLogin, handleSubmit: handleSubmitLogin, watch, trigger, formState: { isValid } } = useForm({
        mode: 'onTouched',
        defaultValues: {
            [USERNAME_ID]: '',
            [PASSWORD_ID]: '',
            [NEW_PASSWORD]: '',
            [REPEAT_MEW_PASSORD]: '',
            [MFA_CODE]: ''
        }
    });
    const { register: registerRecover, handleSubmit: handleSubmitRecover } = useForm({
        mode: 'onTouched',
        defaultValues: {
            [USERNAME_ID]: '',
            [NEW_PASSWORD]: '',
            [REPEAT_MEW_PASSORD]: '',
            [PASSWORD_CODE]: ''
        }
    });
    const {
        login, isLogging, isError,
        isAuthenticating, authenticateUser, userSignIn, //Authenticate user
        smsMfa, loginWithMfa,//Login with MFA
        isRecoveringPassword, sendedEmailToRecoverPassword, setIsRecoveringPassword, sendEmailToRecoverPassword, recoverPassword, //Recover password
        startOidcLogin//Login with SSO
    } = useAuthContext();
    const [isLoading, setIsLoading] = useState(false);

    // Trigger validation when user starts to write password
    const watchPwd = watch(PASSWORD_ID);
    useEffect(() => {
        try {
            if (watchPwd) {
                trigger([USERNAME_ID, PASSWORD_ID]);
            }
        } catch (error) {
            console.error('(LoginScreen page) Error in useEffect to trigger the validation:', error);
            //reportError(error); // Send error report to backend
            logger.error('(LoginScreen page) User: ' + user?.Username + " Tenant: " + tenant + ' Error in useEffect to trigger the validation:', error)
        }
    }, [trigger, watchPwd]);

    useEffect(() => {
        logger.info('User: ' + user?.Username + ' entered in Login Page successful! Tenant: ' + tenant)
    }, [])

    return (
        <>
            {!isRecoveringPassword ?
                <GlobalWrapperRight>
                    <GlobalDropdown />
                </GlobalWrapperRight>
                : <GlobalWrapperLeft>
                    <GlobalDropdown />
                </GlobalWrapperLeft>}

            {!isRecoveringPassword ?
                <LoginPage>
                    <ImageWrapper>
                        <div className="logo">
                            <Image src={tenantConfig.loginLogo} alt='Tenant logo' />
                        </div>
                    </ImageWrapper>

                    {/* Login Form */}
                    <LoginForm style={{ display: (isAuthenticating || isRecoveringPassword) ? 'none' : null }}>
                        <Flex gap={0} vertical="true" style={{ width: '45%' }}>
                            <Text $fontColor='coolgray-12' $fontSize='text_xxl' $weight='medium' $marginBottom='s01'>{t('loginTitle')}</Text>
                            {/* <div className="logo">
                                    <Image src={AdEPorto} alt='AdEPorto logo' />
                                 </div> */}
                            <Text $fontColor='coolgray-12' $fontSize='text_lg' $weight='regular' $marginBottom='s08'>{t('loginMessage')}</Text>

                            <form onSubmit={handleSubmitLogin((data) => login(data))} style={{ display: smsMfa ? 'none' : null }}>

                                <Flex gap='middle' vertical="true">
                                    <Input placeholder={t('username')} name="username" {...registerLogin("username")} style={{ borderColor: error ? '#E82020' : null }} />

                                    <Input type='password' placeholder={t('password')} name="password" {...registerLogin("password")} style={{ borderColor: error ? '#E82020' : null }} />
                                </Flex>
                                <Flex gap={56} vertical='true'>
                                    <Flex justify="flex-end">
                                        <Button className="ant-btn-link" type='link' onClick={() => setIsRecoveringPassword(true)}>
                                            <Text $marginTop='s02' $fontColor='blue-4' $fontSize='text_xs'>{t('forgotPassword') + ' ?'}</Text>
                                        </Button>
                                    </Flex>
                                    {!isLogging ?
                                        <SummitButton type="submit" className="ant-btn ant-btn-black">{t('signIn')}</SummitButton>
                                        : <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            <Spinner stroke="green" size="20px" />
                                        </div>}
                                </Flex>
                            </form>

                            <form onSubmit={handleSubmitLogin((data) => loginWithMfa(data))} style={{ display: !smsMfa ? 'none' : null }}>

                                <Flex gap='middle' vertical="true">
                                    <Input placeholder='Code' name="mfaCode" {...registerLogin("mfaCode")} style={{ borderColor: error ? '#E82020' : null }} />
                                </Flex>

                                <SummitButton type="submit" className="ant-btn ant-btn-black">{t('signIn')}</SummitButton>
                            </form>
                        </Flex>

                        {tenantConfig.showMicoLogin && (
                            <>
                                <Divider style={{ margin: '5px' }} />
                                <Flex justify="flex-end">
                                    <LoginWithSSO type="submit" className="ant-btn" onClick={startOidcLogin}>{tenantConfig.ssoButtonLabel}</LoginWithSSO>
                                </Flex>
                            </>
                        )}
                        {/* <FooterWrapperRight> */}
                        {/* <Icon icon="BrandLogo" width={117} height={40} /> */}
                        {/* <Icon iconsize={'md'} icon="BrandLogo" /> */}
                        {/* </FooterWrapperRight> */}
                    </LoginForm>
                    {/* Authenticate Form */}
                    <LoginForm style={{ display: !isAuthenticating ? 'none' : null }}>
                        <Flex gap={0} vertical="true" style={{ width: 'fit-content' }}>
                            <Text $fontColor='coolgray-12' $fontSize='text_xxl' $weight='medium' $marginBottom='s08'>{t('authenticateUser')} {userSignIn?.['cognito:username']}:</Text>

                            <form onSubmit={handleSubmitLogin((data) => authenticateUser(data))}>
                                <Flex gap={56} vertical='true'>

                                    <Flex gap='middle' vertical="true">
                                        <div id='inputPassword'>
                                            <Input type='password' placeholder={t('newPassword')} name="newPassword"
                                                // style={{ borderColor: error ? '#E82020' : null }}
                                                {...registerLogin("newPassword")}
                                                onChange={(e) => setInputPassword(e.target.value.length >= 8)}
                                            />
                                            {/* {error ?
                                                <Text $fontColor='critical-base' $fontSize='text_xs' $weight='light'>Password must respect the requirements</Text>
                                                : */}
                                            <Flex gap={4} align='center' horizontal='true'>
                                                <Text $fontColor='coolgray-12' $fontSize='text_xs' $weight='light'>{t('inputLabelNewPassword')}</Text>
                                            </Flex>
                                            {/* } */}
                                        </div>
                                        <div id='inputRepeatPassword'>
                                            <Input type='password' placeholder={t('repeatNewPassword')} name="repeatNewPassword" {...registerLogin("repeatNewPassword")}
                                                // style={{ borderColor: error ? Theme.color["critical-base"]: null }}
                                                onChange={(e) => setInputRepeatPassword(e.target.value.length >= 8)} />

                                            {/* {error ?
                                                <Text $fontColor='critical-base' $fontSize='text_xs' $weight='light'>{t('repeatPasswordLabelError')}</Text>
                                                : */}
                                            <Text $fontColor='coolgray-12' $fontSize='text_xs' $weight='light'>{t('repeatPasswordLabel')}</Text>
                                            {/* } */}
                                        </div>
                                    </Flex>
                                    <Space direction="vertical">
                                        {/* <Flex vertical='true'>
                                            <Checkbox onChange={(e) => setCheckTermsConditions(e.target.checked)}>
                                                <Flex gap={2} align='center' horizontal='true'>
                                                    <Text $marginTop='s02' $fontColor='coolgray-12' $fontSize='text_md'>{t('acceptWordOs')}</Text>
                                                    <Button className="ant-btn-link" type='link' href="https://www.google.pt/" onClick={() => setIsRecoveringPassword(true)}>
                                                        <Text $marginTop='s02' $fontColor='blue-4' $weight='regular' $fontSize='text_md'>{t('termsConditions')}</Text>
                                                    </Button>
                                                </Flex>
                                            </Checkbox>
                                            <Checkbox onChange={(e) => setCheckTermsConditions(e.target.checked)}>
                                                <Flex gap={2} align='center' horizontal='true'>
                                                    <Text $marginTop='s02' $fontColor='coolgray-12' $fontSize='text_md'>{t('acceptWordAs')}</Text>
                                                    <Button className="ant-btn-link" type='link' href="https://www.google.pt/" onClick={() => setIsRecoveringPassword(true)}>
                                                        <Text $marginTop='s02' $fontColor='blue-4' $weight='regular' $fontSize='text_md'>{t('cookies')}</Text>
                                                    </Button>
                                                </Flex>
                                            </Checkbox>
                                            <Checkbox onChange={(e) => setCheckTermsConditions(e.target.checked)}>
                                                <Flex gap={2} align='center' horizontal='true'>
                                                    <Text $marginTop='s02' $fontColor='coolgray-12' $fontSize='text_md'>{t('privacyRule')}</Text>
                                                    <Button className="ant-btn-link" type='link' href="https://www.google.pt/" onClick={() => setIsRecoveringPassword(true)}>
                                                        <Text $marginTop='s02' $fontColor='blue-4' $weight='regular' $fontSize='text_md'>{t('privacyRuleLink')}</Text>
                                                    </Button>
                                                </Flex>
                                            </Checkbox>
                                        </Flex> */}

                                        <SummitButton type="submit" className="ant-btn ant-btn-black"
                                            disabled={
                                                // checkTermsConditions && checkCookies && checkPrivacyRule &&
                                                inputPassword && inputRepeatPassword ? false : true}
                                        >{t('authenticateUser')}</SummitButton>
                                    </Space>
                                </Flex>
                            </form>
                        </Flex>

                        {/* <FooterWrapperRight>
                            <Icon icon="BrandLogo" width={117} height={40} />
                        </FooterWrapperRight> */}
                    </LoginForm >
                </LoginPage >
                :
                <LoginPage>
                    {/* Recover Password From */}
                    <LoginForm style={{ display: !isRecoveringPassword ? 'none' : null }}>
                        <Flex gap={16} vertical="true" style={{ width: '45%' }}>
                            {!sendedEmailToRecoverPassword || sendEmailPage ?
                                <form onSubmit={handleSubmitRecover((emailData) => { sendEmailToRecoverPassword(emailData); setSendEmailPage(false) })}>
                                    <Button shape="circle" onClick={() => setIsRecoveringPassword(false)} icon={<Icon icon={'ArrowLeft'} iconsize='sm' color='blue-4' />} />
                                    <Text $fontColor='coolgray-12' $fontSize='text_xxl' $weight='medium' $marginBottom='s01'>{t('recoverPassword')}:</Text>
                                    <Text $fontColor='coolgray-12' $fontSize='text_lg' $weight='regular' $marginBottom='s08'>{t('recoverPasswordDescription')}:</Text>
                                    <Flex gap={56} vertical='true'>
                                        <Flex gap='middle' vertical="true">
                                            <Input placeholder={t('username')} name="username" {...registerRecover("username")}
                                                onChange={(e) => setInputEmail(e.target.value.length > 0)}
                                            />
                                        </Flex>
                                        <SummitButton type="submit" className="ant-btn ant-btn-black"
                                            disabled={inputEmail ? false : true}
                                        >{t('sendEmail')}</SummitButton>
                                    </Flex>
                                </form>
                                : <form onSubmit={handleSubmitRecover((data) => recoverPassword(data))}>
                                    <Button shape="circle" onClick={() => setSendEmailPage(true)} icon={<Icon icon={'ArrowLeft'} iconsize='sm' color='blue-4' />} />
                                    <Text $fontColor='coolgray-12' $fontSize='text_xxl' $weight='medium' $marginBottom='s01'>{t('recoverPassword')}:</Text>
                                    <Text $fontColor='coolgray-12' $fontSize='text_lg' $weight='regular' $marginBottom='s08'>{t('recoverPasswordDescription')}:</Text>
                                    <Flex gap={56} vertical={true}>
                                        <Flex gap='middle' vertical="true">
                                            <div id="code">
                                                <Input placeholder={t('code')} name="passwordCode" {...registerRecover("passwordCode")} />
                                            </div>
                                            <div id="newPassword">
                                                <Input type='password' placeholder={t('newPassword')} name="newPassword" {...registerRecover("newPassword")}
                                                    onChange={(e) => setInputNewPassword(e.target.value.length >= 8)} />
                                                <Flex gap={4} align='center' horizontal='true'>
                                                    <Text $fontColor='coolgray-12' $fontSize='text_xs' $weight='light'>{t('inputLabelNewPassword')}</Text>
                                                </Flex>
                                            </div>
                                            <div id="repeatNewPassword">
                                                <Input type='password' placeholder={t('repeatNewPassword')} name="repeatNewPassword" {...registerRecover("repeatNewPassword")}
                                                    onChange={(e) => setInputRepeatNewPassword(e.target.value.length >= 8)}
                                                />
                                                <Text $fontColor='coolgray-12' $fontSize='text_xs' $weight='light'>{t('repeatPasswordLabel')}</Text>
                                            </div>
                                        </Flex>

                                        <SummitButton type="submit" className="ant-btn ant-btn-black"
                                            disabled={inputNewPassword && inputRepeatNewPassword ? false : true}
                                        >{t('resetPassword')}</SummitButton>
                                    </Flex>
                                </form>}
                            {/* Após receber email de recuperar password e colocar código que recebo no email*/}
                        </Flex>
                        {/* <FooterWrapperLeft>
                            <Icon icon={"BrandLogo"} width={117} height={40} />
                        </FooterWrapperLeft> */}
                    </LoginForm>
                    <ImageWrapper>
                        <div className="logo">
                            <Image src={tenantConfig.loginLogo} alt='Tenant logo' />
                        </div>
                    </ImageWrapper>
                </LoginPage>
            }

        </>)
};

const GlobalDropdown = () => {
    const lngs = {
        en: { nativeName: 'English' },
        pt: { nativeName: 'Portugues' },
        it: { nativeName: 'Italiano' },
    }

    const items = Object.keys(lngs).map((lng, index) => (
        {
            label: <p onClick={() => i18next.changeLanguage(lng)} style={i18next.resolvedLanguage === lng ? { fontWeight: 'bold' } : null}>{lngs[lng].nativeName}</p>,
            key: index,
        }
    ));

    return (
        <LanguageWrapper id='header-dropdown'>
            <Dropdown menu={{ items }} trigger={['click']} getPopupContainer={() => document.getElementById('header-dropdown')}>
                <IconDropdown onClick={(e) => e.preventDefault()}><Icon icon={'Global'} fill='#0076A8' iconsize='md' color={'teal-3'} /></IconDropdown>
            </Dropdown>
        </LanguageWrapper>
    )
};